module.exports = __webpack_public_path__ + "media/static/icons/icon-sandbar-17fd75c1272bbe1fdba0187793a83503.svg";